import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, Image as ImgIcon } from "lucide-react";
import { shopApi, shopperAuth } from "../lib/shop-api";
import { money } from "../lib/api";

export default function WishlistPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const authed = shopperAuth.isAuthed();

  useEffect(() => {
    if (!authed) { setLoading(false); return; }
    shopApi.wishlist().then((d) => { setItems(d); setLoading(false); }).catch(() => setLoading(false));
  }, [authed]);

  if (!authed) {
    return (
      <div className="min-h-screen bg-[#0A0908] text-[#F5F0E6] flex items-center justify-center">
        <div className="text-center">
          <Heart size={40} className="mx-auto text-[#C89B3C] mb-3" />
          <p className="mb-4 text-[#F5F0E6]/70">Inicia sesión para ver tus favoritos.</p>
          <Link to="/shop/account?redirect=/shop/wishlist" className="bg-[#C89B3C] text-[#0A0908] font-bold px-6 py-3 rounded-full">Iniciar sesión</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0908] text-[#F5F0E6]">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-10">
        <p className="text-[11px] uppercase tracking-[0.4em] text-[#C89B3C] mb-2">Mi Lista</p>
        <h1 className="text-4xl mb-8" style={{ fontFamily: "'Playfair Display'", fontWeight: 700 }}>Favoritos</h1>
        {loading ? (
          <p className="text-[#F5F0E6]/60">Cargando…</p>
        ) : items.length === 0 ? (
          <p className="text-[#F5F0E6]/60">Aún no tienes productos guardados.</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="wishlist-grid">
            {items.map((p) => (
              <Link key={p.id} to={`/shop/product/${p.slug}`} className="bg-[#120F0D] border border-white/5 rounded-lg overflow-hidden hover:border-[#C89B3C]/40">
                <div className="aspect-[4/5] bg-black/40">
                  {(p.images || [])[0] ? <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-white/20"><ImgIcon size={30} /></div>}
                </div>
                <div className="p-3">
                  <h3 className="text-sm font-semibold line-clamp-2" style={{ fontFamily: "'Playfair Display'" }}>{p.name}</h3>
                  <p className="text-[#C89B3C] font-bold mt-1">{money(p.price)}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
